export const EFsFileType = {
  "0": "UNKNOWN",
  "1": "AGENCY",
  "-1": "ALL"
};

export const EFsFileSubType = {
  "0": "UNKNOWN",
  "1": "AGENCY_CONTRACT",
  "2": "AGENCY_TRADE_REGISTERY",
  "3": "AGENCY_SEPA_REGISTERY",
  "-1": "ALL"
};

export const EFsFileExtension = {
  "0": "UNKNOWN",
  "1": "PDF",
  "2": "JPG",
  "3": "PNG",
  "4": "DOCX",
  "5": "XLSX",
  "6": "HTML",
  "7": "XML",
  "-1": "ALL"
};